export const styles = {
    loading: {
        minHeight: '100%',
        display: 'flex',
        justifyContent: 'center'
    },
    tableLoading: {
        position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        left: 0,
        right: 0,
        bottom: 0,
        top: 0,
    },
    formLoading: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
};